export const fmtUsd = (v, d = 2) => {
  if (v === null || v === undefined || isNaN(v)) return "—";
  const n = Number(v);
  return n.toLocaleString("tr-TR", { minimumFractionDigits: d, maximumFractionDigits: d });
};

export const fmtNum = (v, d = 4) => {
  if (v === null || v === undefined || isNaN(v)) return "—";
  return Number(v).toLocaleString("tr-TR", { minimumFractionDigits: 0, maximumFractionDigits: d });
};

export const fmtPct = (v, d = 2) => {
  if (v === null || v === undefined || isNaN(v)) return "—";
  const n = Number(v);
  return `${n > 0 ? "+" : ""}${n.toFixed(d)}%`;
};

export const fmtVol = (v) => {
  if (v === null || v === undefined || isNaN(v)) return "—";
  const n = Number(v);
  if (n >= 1e9) return (n / 1e9).toFixed(2) + " Mr";
  if (n >= 1e6) return (n / 1e6).toFixed(2) + " M";
  if (n >= 1e3) return (n / 1e3).toFixed(1) + " B";
  return n.toFixed(0);
};

export const fmtTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "medium" });
  } catch {
    return iso;
  }
};

export const pnlColor = (v) => (Number(v) > 0 ? "text-[#10B981]" : Number(v) < 0 ? "text-[#EF4444]" : "text-[#94A3B8]");

export const binanceFuturesUrl = (symbol) => `https://www.binance.com/en/futures/${symbol}`;
export const tradingViewUrl = (symbol, interval = "5") => `https://www.tradingview.com/chart/?symbol=BINANCE:${symbol}.P&interval=${interval}`;
